import { render, staticRenderFns } from "./_tag_name.vue?vue&type=template&id=bd745116&"
import script from "./_tag_name.vue?vue&type=script&lang=js&"
export * from "./_tag_name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CatalogsFilter: require('/builds/master/frontend/frontend-universe/components/catalogsFilter.vue').default})
